// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2JEw7","header":"ClearentDisclaimer_header__35G9R","inner":"ClearentDisclaimer_inner__1jHEi"};